<template>
  <div class="form-control input password">
          <input
            :type="visibility ? 'text' : 'password'"
            v-model="password"
            name="password"
            class="form-control"
            :class="{ 'is-invalid': submitted && !password }"
            placeholder="Contraseña"
            v-on:change="(event) => this.$emit('inputChangePassword', event)"
          />
          <div v-show="submitted && !password" class="invalid-feedback">
            La contraseña es obligatoria
          </div>
          <img
            class="password-visibility"
            @click="setVisibility()"
            :src="'https://mi.rastreator.com/img/' + icon"
          />
  </div>
</template>

<script>
export default {
props : ['submitted'],
data() {
    return {
      password: "",
      error: "",
      visibility: false,
    };
  },
  computed: {
    icon() {
      return this.visibility ? "visible.svg" : "not-visible.svg";
    },
  },
  methods: {
      setVisibility() {
      this.visibility = !this.visibility;
    //   console.log(submitted);
    }
  },
}
</script>

<style>

</style>